import { render } from "./COIActionBarRefund.vue?vue&type=template&id=a0eda234"
import script from "./COIActionBarRefund.vue?vue&type=script&lang=js"
export * from "./COIActionBarRefund.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__